import { useContext, useState } from "react";
import { ObjectContext } from "@providers/ObjectProvider";
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import Table from '@mui/joy/Table';
import Stack from '@mui/joy/Stack';
import ObjectRelationshipCard from '@components/objects/ObjectRelationshipCard';
import { gradientTint } from "@utils/gradientTint";
import { useGetUser } from "@api/userService";
import AbstractObjectRelationship from "./AbstractObjectRelationship";
import { Alert, LinearProgress } from "@mui/joy";
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import GppBadRoundedIcon from '@mui/icons-material/GppBadRounded';
import { yesNo } from "@utils/yesNo";
import { userRoles } from "@utils/selectOptions";
import { ObjectPrimaryInfoEdit } from "./ObjectPrimaryInfoEdit";

const fields = [
  {
    name: 'email_required',
    type: 'info',
    conditional: (object) => !object.email,
    content: () => (<>
    Please add the contact's email address to enable user access settings.
    </>)
  },
  {
    name: 'has_access',
    label: 'Active',
    type: 'boolean',
    inputLabel: 'Give access to Maestro',
    conditional: (object) => !!object.email,
  },
  {
    name: 'role_id',
    type: 'relationship',
    endpoint: 'roles',
    loadAll: true,
    conditional: (object) => !!object.email && object.has_access,
    config: {
      validate: (value, object) => {
        if (!value && object.has_access) return 'Users must have a role';
        return true;
      },
    },
    content: (object) => (
      <Typography sx={{fontSize: 'sm', mt: 1}}><a target="_blank" href="https://www.maestrocm.com/user-tiers/">Need help with user roles?</a></Typography>
    ),
  },
  {
    name: 'is_staff',
    label: 'Staff Member?',
    type: 'boolean',
    inputLabel: 'Is a staff member',
    conditional: (object) => !!object.email && object.has_access,
  },

];

export default function UserAccessCardEdit({
  // relationship,
  title,
  tint = null,
}) {
  // const isEmpty = !relationship;
  const data = useContext(ObjectContext);
  const userId = data?.user_id ?? 0;

  // TODO: put this into an effect and only load it once
  const {
    // isPending,
    isLoading,
    isError,
    error,
    data: userData,
    isFetching,
    isPreviousData,
  } = useGetUser(userId, {
    enabled: userId > 0,
    retry: false,//1,
  });

  const shortName = data?.first_name ?? data?.name ?? 'N/A';
  const hasAccess = userId > 0 && userData;

  /*

    const {
        // isPending,
        isLoading,
        isError,
        error,
        data: searchResults,
        isFetching,
        isPreviousData,
    } = useGetAll({
        queryKey: ['search', debouncedSearchTerm],
        enabled: debouncedSearchTerm.length > 0,
    }, {
        term: debouncedSearchTerm,
    });
  */

  const getRolesForUser = ():string => {
    if(!userData?.roles?.[0]) {
      return 'N/A';
    }

    let roles:string[] = [];

    userData.roles.map(role => {
      const findRole = userRoles.find(r => r.value === role.id);
      roles.push(findRole?.label ?? role.name);
    });

    return roles.join(', ');

    /*
    {userData?.roles?.map((role, roleInd) => (
      <span key={roleInd}>{userRoles.find(role => role.value === role.id)?.label ?? 'N/A'}</span>
    ))[0]?.name ?? 'N/A'}
    return '';
    */
  }

  return (
    <ObjectPrimaryInfoEdit
      title={'User Access'}
      tint={'default'}
      fields={fields}
    />
  );
}
